// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__4iO2c","modal":"Loader_modal__2HQ3+","slide-down":"Loader_slide-down__K8rgO"};